import { useContext } from "react";
import { AuthContext } from "../../context/auth";

export default () => useContext(AuthContext);
